module.exports = __webpack_public_path__ + "assets/arrival.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrival.svg
// module id = 1656
// module chunks = 7